import { render, staticRenderFns } from "./SkinRegimen.vue?vue&type=template&id=9b7c07fa&"
import script from "./SkinRegimen.vue?vue&type=script&lang=js&"
export * from "./SkinRegimen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports